"use client";

import { useTranslations } from "next-intl";

import { ProjectCard } from "@/components/ui/projectCard";
import { useProjectFilterStore } from "@/store/useProjectFilterStore";

import { useFavoritesProjects } from "../queries/useFavoritesProjects";
import { useProjectList } from "../queries/useProjectList";
import { ItemList } from "./itemList";
import { ProjectFilterDrawer } from "./projectFilterDrawer";
import { ProjectFilterTags } from "./projectFilterTags";

export function ProjectList() {
  const t = useTranslations("home");
  const applied = useProjectFilterStore((state) => state.applied);
  const reset = useProjectFilterStore((state) => state.reset);
  const search = useProjectFilterStore((state) => state.search);
  const setSearch = useProjectFilterStore((state) => state.setSearch);
  const matchMode = useProjectFilterStore((state) => state.matchMode);
  const setMatchMode = useProjectFilterStore((state) => state.setMatchMode);

  return (
    <ItemList
      title={t("projectList.title")}
      applied={applied}
      onResetFilters={reset}
      search={search}
      onSearchChange={setSearch}
      matchMode={matchMode}
      onMatchModeChange={setMatchMode}
      useAllQuery={useProjectList}
      useFavoritesQuery={useFavoritesProjects}
      renderCard={(item, accountId, listParams) => (
        <ProjectCard
          key={item.project_code}
          item={item}
          accountId={accountId}
          listParams={listParams}
        />
      )}
      FilterDrawer={ProjectFilterDrawer}
      FilterTags={ProjectFilterTags}
      loadingText={t("projectList.loading")}
      errorText={t("projectList.error")}
    />
  );
}
